import React, {useState, useEffect} from "react";
import {useNavigate, useLocation, Link} from "react-router-dom";
import  {get_golfer_memberships_data} from "../../API/APICalls";
import { AGA_CLUB_ID_AND_LOGO } from "../constants";
import { differenceInDays } from 'date-fns';
import {normalizeInput, normalizeDate, calculate_age, isvalid_mdy,normalizeUSDate} from '../functions';

export default function DashboardForm () {

    const navigate = useNavigate();
    const location = useLocation();
    const [deals, setDeals] = useState<any[]>([]);
    const [isAutoRenew, setisAutoRenew] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState(false);

    const club_memberships:any[] = []

    let contact_guid=location?.state?.contact_guid;
    let handicap_id=location?.state?.handicap_id;





  
    
    useEffect(() => {
        
        if (!location.state)
            {   
                navigate("/");
            } else {
              
            
        
        //get memberships 
        get_golfer_memberships_data(contact_guid).then((response) => {
            if (JSON.parse(response || '').combinedDealCompany.length > 0)
            {
         
                for (const record of JSON.parse(response || '').combinedDealCompany) {
                    
                    if (AGA_CLUB_ID_AND_LOGO.find(club=>club.club_id == record.usga_aga_gc_club_id)) {

                        //check the effective dates for buttons   
                                    
                        const current_date = new Date();
                        const effective_date = new Date(record.createdate);

                        const diffDays = differenceInDays(current_date, effective_date.toLocaleDateString());

                        
                        club_memberships.push([record, diffDays]);
                        
                    // console.log(club_memberships);
                        setIsLoading(false);
                    }

                }
                
                setDeals(club_memberships);
            } else {
                setIsLoading(false);
                setMessage(true);
            }
           
        })
    }    
    }, []);


    return (  
        <div className="container page_container mt-5 mb-5">
            <div className="row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 pb-2">
                <div className="col-7 col-sm-4 col-md-12 col-lg-8"><h1 className="fs-1 text-left fw-normal">Membership Information</h1></div>
                <div className="row col-5 col-lg-4 p-0 m-0">
                    <div className="col-8 text-end pt-1"><h1 className="fs-5 text-left fw-normal"><Link to="/membership/manage/personal" state={{"contact_guid": contact_guid, "handicap_id": handicap_id}} className="text-decoration-none text-secondary">My Profile</Link></h1></div>
                    <div className="col-4 text-end pt-1"><h1 className="fs-5 text-left fw-normal"><Link to="/" className="text-decoration-none text-secondary">Logout</Link></h1></div>
                </div>
            </div>
           
            {isLoading ? 
            <div className="loaderWrapper">
              <div className="loader"></div>
            </div>
            : ''}

            {message ? <div className="col-12 text-center"><span>No active memberships exist.</span></div> : ''}
            
            {deals && deals.map((results, index) => (
            
            <div className="row" key={index}>
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-1 text-start" id="logo-align">
                    <img className="img-fluid ps-2" id="logo-img-align" src={results[0].aga_logo} />
                </div>
                
                <div className="col-10 col-sm-6 col-md-6 col-lg-6 col-xl-6 pt-3">
                    <h4 className="">{results[0].association_name}</h4>
                    <h4 className="fs-5">{results[0]['club_name']}</h4>
                    
                    
                    {
                        results[0].dealstage == "Inactive" ? <span className="badge text-bg-secondary fs-6">{results[0].dealstage}</span> :  <span className="badge text-bg-success fs-6">{results[0].dealstage}</span>
                    }
       
                    
                    {results[0].createdate == null ? '' : <div className="py-1 fs-5">Expires: {normalizeUSDate(results[0].expiration_date)}</div> 
                    }
                       
                </div>

                {results[0].dealstage != "Inactive" ?
                <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 mt-4">
                    <div className="py-2"><Link to="/membership/manage/payment" state={{"contact_guid": contact_guid, "handicap_id": handicap_id,"dealId": results[0].dealid, "membership":results[0]}} className="btn btn-outline-primary w-100 btn-lg px-5 rounded-pill" type="submit">Manage Payment</Link></div>
                    <div className="py-2"><Link to="/membership/manage/autorenew" state={{"contact_guid": contact_guid, "handicap_id": handicap_id, "dealId": results[0].dealid, "membership":results[0]}} className="w-100 btn btn-outline-primary btn-lg rounded-pill px-5 " type="button">Manage Auto-Renew</Link></div>
                    <div className="py-2"><Link to="/membership/manage/cancel" state={{"contact_guid": contact_guid, "handicap_id": handicap_id, "dealId": results[0].dealid, "membership":results[0]}} className="w-100 btn btn-outline-primary btn-lg rounded-pill px-5 " type="button">Cancel Membership</Link></div>
                    
                    {results[1] >= 14 ? '' : 
                    <div className="py-2"><Link to="/membership/manage/refund" state={{"contact_guid": contact_guid, "handicap_id": handicap_id, "dealId": results[0].dealid}} className="btn btn-outline-primary w-100 btn-lg px-5 rounded-pill" type="submit">Request Refund</Link></div>
                    }
                </div>
                : '' }
                <div className="py-3"><hr /></div>
            </div>
            
            ))}
            
               
                    
        </div>
        

    );
}